import { Capacitor } from '@capacitor/core';

// True only inside a native Capacitor build (Android today, iOS once it ships) — false in any
// web browser, including the deployed web app and local `ng serve`. Gate for offline/IndexedDB
// features intentionally scoped to native mobile only: see offline.guard.ts and offline/*.
export function isOfflineCapableNative(): boolean {
  return Capacitor.isNativePlatform();
}

// True only inside the native iOS app. Apple's App Store guidelines forbid any link, button,
// or explicit direction in-app that steers a user toward an external purchasing mechanism
// (unlike Google Play, which requires exactly that via the Android Custom Tab handoff — see
// AndroidPaymentHandoffGuard). Gate for hiding/neutralizing every purchase-intent CTA
// ("Upgrade", "Renew", "Try Again" on a failed payment, etc.) on iOS only.
// `tms_force_ios_native` is a manual override for previewing the iOS-only behavior in a desktop
// browser — no Mac/TestFlight build exists yet (see the Phase-6 iOS plan) — mirrors the same
// override pattern TallyKeypadService already uses for its iOS-default keypad.
export function isIosNative(): boolean {
  if (typeof localStorage !== 'undefined') {
    const override = localStorage.getItem('tms_force_ios_native');
    if (override === '1') return true;
    if (override === '0') return false;
  }
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
}
